import { render } from "./JobReplyOnFeedback.vue?vue&type=template&id=a70d56dc"
import script from "./JobReplyOnFeedback.vue?vue&type=script&lang=js"
export * from "./JobReplyOnFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__